// Financiero › Resumen › Dashboard Financiero.
// Antes eran dos opciones de menú separadas —"Dashboard de Ventas" y "Dashboard
// de Compras"— que miden lo mismo en los dos sentidos del negocio. Quien mira el
// mes rara vez quiere una sin la otra, así que ahora son dos pestañas.
//
// Las dos rutas antiguas siguen vivas: /financiero/dashboard-compras entra
// directo a la pestaña de compras, así que no se rompe ningún enlace guardado.
import { useState } from 'react';
import { ArrowDownLeft, ArrowUpRight } from 'lucide-react';
import { DashboardVentas } from './DashboardVentas';
import { DashboardCompras } from './DashboardCompras';

export function DashboardFinanciero({ inicial = 'ventas' }: { inicial?: 'ventas' | 'compras' }) {
  const [tab, setTab] = useState<'ventas' | 'compras'>(inicial);
  return (
    <div className="min-h-full">
      <div className="flex gap-1 border-b px-6 pt-4">
        {([
          ['ventas', 'Ventas', ArrowUpRight],
          ['compras', 'Compras', ArrowDownLeft],
        ] as const).map(([k, label, Icono]) => (
          <button key={k} onClick={() => setTab(k)}
            className={`-mb-px flex items-center gap-1.5 border-b-2 px-4 py-2 text-sm ${tab === k
              ? 'border-primary font-medium text-primary'
              : 'border-transparent text-muted-foreground hover:text-foreground'}`}>
            <Icono className="h-4 w-4" /> {label}
          </button>
        ))}
      </div>
      {tab === 'ventas' ? <DashboardVentas /> : <DashboardCompras />}
    </div>
  );
}
